import { Location } from 'app/profile/models/profile.model';
import { UnitOfMeasure } from 'app/profile/models/site.model';

export interface SiteState {
    manufacturingLocations: Location[] | null;
    unitOfMeasures: UnitOfMeasure[] | null;
}

export const initialState: SiteState = {
    manufacturingLocations: null,
    unitOfMeasures: null,
};
